// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\OfferListResponse

import { hydrateOffer, type Offer, type OfferApiResponse } from './offer.gen';

export type OfferListApiResponse = {
	items: OfferApiResponse[];
};

export type OfferList = {
	items: Offer[];
};

export function hydrateOfferList(data: OfferListApiResponse): OfferList {
	return {
		...data,
		items: data.items.map(hydrateOffer),
	};
}